<template>
  <v-container fluid>
    <v-card class="pb-2">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-row align-content="center">
          <v-col
              cols="10"
              align-self="center">
            <v-toolbar-title class="textwithbackground--text">
              {{ $t('Настройки SMTP') }}
            </v-toolbar-title>
          </v-col>
          <v-col cols="2" class="text-right">
            <btn-icon-tip
                icon="edit"
                icon-color="secondaryiconbtn"
                :tip="$t('Редактировать настройки')"
                :disabled="isLoading"
                @click="openEditSMTPSettingsDialog" />
            <edit-s-m-t-p-settings-dialog
                v-if="editSMTPSettingsDialog.show"
                :dialog-prop="editSMTPSettingsDialog"
                @close="closeDialog('editSMTPSettingsDialog')" />
          </v-col>
        </v-row>
      </v-toolbar>
      <v-row class="text-left pa-2 ma-2 ml-4">
        <v-col>
          <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
            <v-col cols="12">
              <v-progress-linear :active="isLoading" color="loader" indeterminate />
            </v-col>
            <v-col class="mx-1">
              <general-error v-if="!!generalError" />
            </v-col>
          </v-row>
          <v-row
              v-if="isAdmin">
            <text-view
                multiline
                :display="settings.host"
                :label="$t('Хост')" />
            <text-view
                multiline
                :display="settings.port"
                :label="$t('Порт')" />
            <text-view
                multiline
                :display="settings.userName"
                :label="$t('Пользователь')" />
            <text-view
                :display="showPassword
                  ? settings.password
                  : '***'"
                :label="$t('Пароль')"
                multiline
                :icon-color="showPassword
                  ? 'error'
                  : 'success'"
                :icon="showPassword
                  ? 'visibility_off'
                  : 'visibility'"
                @click:prepend-icon="showPassword=!showPassword" />
            <text-view
                multiline
                :display="settings.mailFrom"
                :label="$t('Адрес отправителя')" />
            <text-array-view
                v-if="isMainAdmin"
                md="6"
                :display="settings.adminsEmails"
                :label="$t('Адреса администраторов системы')" />
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>

  import EditSMTPSettingsDialog from '@/components/pages/admin/SystemSettings/EditSMTPSettingsDialog.vue'
  import TextView from '@/components/reused/ui/TextView.vue'
  import TextArrayView from '@/components/reused/ui/TextArrayView.vue'
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { mapActions, mapState } from 'vuex'
  import { SYSTEM_SETTINGS } from '@/constants/store.js'

  export default {
    components: {
      TextView,
      GeneralError,
      BtnIconTip,
      TextArrayView,
      EditSMTPSettingsDialog
    },
    data () {
      return {
        isLoading: false,
        showPassword: false,
        editSMTPSettingsDialog: {
          settings: null,
          callback: null,
          show: false
        }
      }
    },
    computed: {
      ...mapState(SYSTEM_SETTINGS.NAMESPACE, {
        settings: state => (state[SYSTEM_SETTINGS.STATE.SMTP_SETTINGS] || {})
      })
    },
    created () {
      Promise.all([
        this.getSMTPSettings()
      ])
    },
    beforeDestroy () {
      this.clearSMTPSettingsAction()
    },
    methods: {
      ...mapActions(SYSTEM_SETTINGS.NAMESPACE, {
        getSMTPSettingsAction: SYSTEM_SETTINGS.ACTIONS.GET_SMTP_SETTINGS,
        clearSMTPSettingsAction: SYSTEM_SETTINGS.ACTIONS.CLEAR_SMTP_SETTINGS
      }),
      getSMTPSettings: async function () {
        try {
          this.isLoading = true
          await this.getSMTPSettingsAction()
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      openEditSMTPSettingsDialog: function () {
        this.editSMTPSettingsDialog.settings = this.settings
        this.editSMTPSettingsDialog.callback = this.getSMTPSettings
        this.editSMTPSettingsDialog.show = true
      }
    }
  }
</script>
